module.exports = __webpack_public_path__ + "assets/img/accordion-plus.c9fb6ca6.svg";